import { dot, MathArray } from 'mathjs';
import { normalizeMathArray } from 'utilities';

const SUMPRODUCT = (x: MathArray, y: MathArray) => {
  const normalizedX = normalizeMathArray(x);
  const normalizedY = normalizeMathArray(y);

  return dot(normalizedX, normalizedY);
};

export default SUMPRODUCT;
